import { Flex, Spinner } from "@chakra-ui/react";
import { ExchangeRateSource } from "@src/__generated__/graphql";
import { NumberInput } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useInvoiceStore } from "../store";

type ExchangeRateInputProps = {
  value: number;
  isLoading: boolean;
  selectedSource: ExchangeRateSource;
  sourceCurrencyCode?: string;
  onChange: (value: string) => void;
};
export const ExchangeRateInput = observer(function ExchangeRateInput({
  value,
  isLoading,
  selectedSource,
  sourceCurrencyCode,
  onChange,
}: ExchangeRateInputProps) {
  const { workspaceStore } = useStore();
  const store = useInvoiceStore();

  return (
    <NumberInput
      currency
      disabled={isLoading || selectedSource !== ExchangeRateSource.Custom}
      prefix={`1 ${sourceCurrencyCode ?? workspaceStore.settings?.currency.code} =`}
      prefixStyles={{ w: 16 }}
      inputStyle={{ paddingLeft: 16 }}
      suffix={
        <Flex align="center">
          {isLoading && <Spinner mr="2" size="sm" />}
          {store.selectedCurrency.code}
        </Flex>
      }
      value={value.toString()}
      onChange={onChange}
    />
  );
});
